import { jdBlack, jdGreen, Theme } from "@deere/fuel-react";
import LocalStorage from "./LocalStorage";

const THEMES = {
  DeereGreen: jdGreen,
  DeereYellow: jdBlack,
};

export type ThemeName = keyof typeof THEMES;

const isValidThemeName = (themeName: string | null): boolean => {
  if (!themeName) {
    return false;
  }
  return Object.keys(THEMES).includes(themeName);
};

export const saveTheme = (themeName: ThemeName) =>
  LocalStorage.setJSONValue("theme", { theme: themeName });

const getStoredTheme = (): ThemeName | undefined => {
  const themeName = LocalStorage.getJSONValue("theme")?.theme as ThemeName;
  return isValidThemeName(themeName) ? themeName : undefined;
};

const getThemeFromUrl = (): ThemeName | undefined => {
  const urlParams = new URLSearchParams(window.location.search);
  const themeNameFromUrl = urlParams.get("theme");
  return isValidThemeName(themeNameFromUrl)
    ? (themeNameFromUrl as ThemeName)
    : undefined;
};

export const getTheme = (): Theme => {
  const DEFAULT_THEME_NAME = "DeereGreen";
  const themeName =
    [getThemeFromUrl(), getStoredTheme()].find((theme) => theme) ||
    DEFAULT_THEME_NAME;
  return THEMES[themeName];
};
